import React from 'react';
import { Box, Container, Link, Stack, Text } from 'bumbag';

import TyroHealthDarkLogo from '@medipass/assets/images/Tyro/dark.png';

import { THO_PRIVACY_POLICY_URL, THO_URL } from '../../../../constants';

export default function Footer() {
  return (
    <Container
      breakpoint="checkout"
      display="flex"
      alignItems="center"
      justifyContent="center"
      paddingTop="major-3"
      paddingBottom="major-3"
    >
      <Stack spacing="major-1">
        <Box display="flex" justifyContent="center">
          <Box color="text100">Powered by</Box>
          <img src={TyroHealthDarkLogo} className="ml-2 w-40" alt="Tyro Health Online" />
        </Box>
        <Box display="flex" justifyContent="center">
          <Link href={THO_URL} target="_blank" rel="noreferrer noopener">
            Learn more
          </Link>
          <Text> | </Text>
          <Link href={THO_PRIVACY_POLICY_URL} target="_blank" rel="noreferrer noopener">
            Privacy policy
          </Link>
        </Box>
      </Stack>
    </Container>
  );
}
